import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Badge } from "./BadgeBlock";
import { defaultData } from "./BadgeBlockDefaultData";
import { meta } from "./BadgeBlockMetaData";

export const BadgeBlock: BlockExport = {
  type: "component",
  Block: Badge,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-badge",
    size: 24,
  },
  defaultData,
  meta,
};
